import Vue from "vue";
import { MLInstaller, MLCreate, MLanguage } from "vue-multilanguage";

Vue.use(MLInstaller);

const texteDeu = {
  Nav: {
    title: "Rutschenkonfigurator",
    highscore: "Highscore",
    strecken: "Strecken",
  },
  Home: {
    title: "Rutschenkonfigurator",
    subTitle:
      "Du willst, dass dein Besuch in den Spreewelten etwas ganz besonderes wird?",
    text:
      "Erstelle deine eigenen Rutschenkonfigurationen direkt von zu Hause oder von unterwegs! Bestimme die Musik, das Licht und viele weitere spektakuläre Effekte für bis zu drei individuelle Rutschenprofile. Wenn du dann vor Ort an der Rutsche stehst, kannst du aus deinen eigenen und weiteren Rutschenprofilen wählen.",
    textNewAccount: "Neu hier?",
    btnAnmelden: "Anmelden",
    btnRegistrieren: "Registrieren",
    btnNewAccount: "Account erstellen",
    btnBack: "Zurück",
    placeholderCode: "4-stelliger Zahlencode",
    labelPassword: "Passwort",
    confirm: "Passwort bestätigen",
    forgotPassword: "Passwort vergessen?",
    anmelden: "Anmeldung",
    registrieren: "Registrieren",
    Impressum: "Impressum",
    Datenschutz: "Datenschutz",
    Kontakt: "Kontakt",
  },
  Footer: {
    Impressum: "Impressum",
    Datenschutz: "Datenschutz",
    Kontakt: "Kontakt",
    linkImpressum:
      "https://www.spreewelten.de/footer-meta-navigation/impressum.html",
    linkDatenschutz:
      "https://www.spreewelten.de/footer-meta-navigation/datenschutz.html",
    linkKontakt: "https://www.spreewelten.de/kontakt.html",
  },
  Login: {
    title: "HALLO, LIEBE SLIDER!",
    text:
      "Meldet euch mit eurem Nickname und eurem Passwort an. Sobald ihr eingeloggt seid, könnt ihr eure persönlichen Strecken konfigurieren oder euch die Rutsch-Statistiken ansehen.",
    name: "Nickname",
    loggedIn:
      "Hi {name}, du bist bereits eingeloggt. Hier kannst du dich ausloggen:",
    loggedInAlternative:
      "Hi <b>{newUser}</b>, du bist derzeit noch als <b>{name}</b> eingeloggt. Hier kannst du dich ausloggen:",
    validation: "Dein Nickname muss mind. 3 Buchstaben oder Zahlen haben.",
    validationPassword: "Passwort muss aus 4 Zahlen bestehen.",
    labelPassword: "Passwort",
    placeholderCode: "4-stelliger Zahlencode",
    connectProfile: "Anmelden und verknüpfen",
    anmelden: "Anmelden",
    wait: "Bitte warten...",
  },
  Register: {
    title: "HALLO, LIEBE SLIDER!",
    text:
      "Ihr müsst euch zuerst registrieren, damit ihr eure persönlichen Strecken konfigurieren oder euch die Slider-Statistiken ansehen könnt. Meldet euch mit eurem Nickname und eurem Passwort an. Sobald ihr eingeloggt seid, könnt ihr eure persönlichen Strecken konfigurieren oder euch die Slider-Statistiken ansehen.",
    name: "Nickname *",
    loggedIn:
      "Hi {name}, du bist bereits eingeloggt. Hier kannst du dich ausloggen:",
    noToken:
      "Hi, bitte geh zurück auf www.aquarium-schwedt.de/de/login und klicke auf 'Neuen Rutscher anlegen'",
    validation: "Dein Nickname muss mind. 3 Buchstaben oder Zahlen haben.",
    validationPassword: "Passwort muss aus 4 Zahlen bestehen.",
    validationPassword2: "Passwort muss übereinstimmen.",
    labelPassword: "Passwort *",
    labelPassword2: "Passwort wiederholen *",
    placeholderCode: "4-stelliger Zahlencode",
    connectProfile: "Anmelden und verknüpfen",
    register: "Jetzt Registrieren",
    wait: "Bitte warten...",
    birthday: "Geburtsdatum",
    gender: "Geschlecht",
    options: "Bitte triff deine Auswahl",
    info: "Mit * gekennzeichnete Felder sind Pflichtfelder.",
  },
  ConfigTile: {
    platzhalter: "Hier ist noch Platz für eine Strecke",
  },
  ConfiguratorStart: {
    title: "Konfigurator",
    nameIt: "Gib deiner Strecke einen Namen",
    instruction:
      "Lass deiner Phantasie freien Lauf und suche dir einen tollen Namen für deine individuelle Strecke aus!",
    btnCancel: "Abbrechen",
    btnGo: "Los geht's",
  },
  Configurator: {
    title: "Neue Strecke",
    btnNewSlide: "Strecke erstellen",
    btnSaveSlide: "Speichern",
    btnBack: "Zurück",
    btnProceed: "Weiter",
    langsam: "sehr langsam",
    normal: "normal",
    schnell: "schnell",
    streckeVerwerfen: "Strecke verwerfen",
    streckeErstellen: "Strecke erstellen",
    aenderungenVerwerfen: "Änderungen verwerfen",
    aenderungenSpeichern: "Änderungen speichern",
    frageZufrieden: "Nicht zufrieden?",
    color: "Farbe",
    speed: "Speed",
    effekt: "Effekt",
    abschnitt: " Abschnitt",
    musik: "Musik",

    instruction1:
      "Im Twister, dem {step}. Rutschenabschnitt, kannst du einen Effekt und die Effektgeschwindigkeit wählen. Stell ein was dir gefällt und klicke dann auf „Weiter“. So gelangst du zum {nextstep}. Abschnitt.",
    instruction2:
      "Der {step}. Rutschenabschnitt lässt dich zusätzlich eine Farbe festlegen. In der Vorschau kannst du deinen Abschnitt kontrollieren. Wenn du fertig bist, klicke auf „Weiter“. So gelangst du zum {nextstep}. Abschnitt.",
    instruction3:
      "Der {step}. Rutschenabschnitt besteht aus vier Stroboskoben, die unterschiedlich schnell blinken können. Wähle die gewünschten Geschwindigkeiten. Die Vorschau zeigt dir den zuletzt eingestellten Wert an.",
    instruction4:
      "Im {step}. Rutschenabschnitt kannst du erneut einen Twister einstellen. Wähle aus Effekt und Effektgeschwindigkeit!",
    instruction5:
      "Der letzte Rutschenabschnitt enthält einen Stroboskop-Effekt. Wähle hier aus wie schnell die Stroboskope blinken sollen. Wenn du fertig bist, klicke auf „Weiter“. So gelangst du zur Übersicht, in der du auch die passende Musik wählen kannst.",
    title6: "Sieht gut aus!",

    instruction6:
      "Super! Du hast nun alle Abschnitte gestaltet! Jetzt fehlt deiner Strecke nur noch die passende Musik. Wähle aus der Liste deinen Lieblingshit, den du dir zur Probe anhören kannst. Wenn auch die Musik passt, klicke auf {label}. Fertig!",
    musicDescription: "Wie klingt deine Strecke?",
    music: "Musik",
    musicChoice: "Bitte triff deine Auswahl",
  },
  LogoutDialog: {
    option1: "Abmelden und<br /> zurück zum Slider-Profil",
    option2: "<b>Ohne</b> Abmelden<br /> zurück zum Slider-profil",
    btnCancel: "Abbrechen",
    link: "https://www.spreewelten.de/die-rutsche/login.html",
  },
  MusicPlayer: {
    listen: "<b>Probehören</b>",
  },
  Notification: {
    title404: "Server nicht erreichbar",
    text404:
      "Der Server ist aktuell nicht erreichbar. Bitte probiere es zu einem späteren Zeitpunkt erneut.",
    title401: "Bitte überprüfe deine Eingaben",
    text401:
      "Der Server ist aktuell nicht erreichbar. Bitte probiere es zu einem späteren Zeitpunkt erneut.",
    titleGeneral: "Ups!",
    textGeneral:
      "Da ist etwas schief gelaufen oder der Server ist nicht zu erreichen. Bitte probiere es erneut!",
    2000: "Der Benutzername wird bereits verwendet. Bitte wähle einen anderen Namen.",
    2010: "Der Benutzername ist zu lang oder zu kurz",
    2015: "Bitte gib deinen Benutzernamen und Passwort an.",
    2020: "Der Benutzername enthält Sonderzeichen",
    2030: "Dieser Benutzername ist geblockt",
    2040: "Der Code ist nicht vier Zeichen lang",
    2050: "Der Code enthält unzulässige Zeichen",
    2060: "Zu ihrer Sitzung konnte kein Token gefunden werden. Kehren Sie bitte zum 'https://www.spreewelten.de/die-rutsche/login.html' zurück um mit der Registrierung eines Nutzers zu beginnen!",
    2070: "Zu ihrer Sitzung konnte kein Token gefunden werden. Kehren Sie bitte zum 'https://www.spreewelten.de/die-rutsche/login.html' zurück um mit der Verknüpfung eines Nutzers zu beginnen!",
    2100: "Falsches Passwort",
    2110: "Der Benutzername ist nicht vergeben",
  },
  ScorePanel: {
    platzhalter: "Keine Scores vorhanden",
    platzhalterTimes: "Keine Zeiten vorhanden",
  },
  TimePanel: {
    platzhalter: "Keine Scores vorhanden",
  },
  Highscores: {
    greeting: "Hi {name}",
    text: "Hier kannst du die Highscores einsehen.",
    punkte: "Punkte",
    punkte24: "Punkte (24h)",
    zeiten: "Zeiten",
    zeiten24: "Zeiten (24h)",
    distanz: "Distanz",
    distanz24: "Distanz (24h)",
  },
  Dashboard: {
    greeting: "Hi {name}",
    btnCancel: "Abbrechen",
    btnConfirm: "Bestätigen",
    btnNew: "Neue Strecke erstellen",
    btnHighscores: "Highscores ansehen",
    distance: "Du bist schon <b> {distance}m </b> gerutscht.",
    lastSlide: "Deine Punkte vom letzten Rutschen: <b> {latestPoints} </b>",
    notYet: "Du bist bisher noch nicht gerutscht.",
    deleteAsk:
      "Möchtest du die ausgewählte Rutsche <b>{nameOfSelectedConfig}</b> löschen?",
    askTitle: "Bist du dir sicher?",
    description: "So funktioniert es",
    generalTitle: "Meine Strecken",
    generalText:
      "Du kannst bis zu drei unterschiedliche Lieblingsslides gestalten. Bestehende Strecken können jederzeit verändert werden. Leg am besten gleich los!",
    step1Title: "1. Erstelle deine Strecke",
    step1Text:
      "Gib deiner Strecke einen Namen. Gestalte dann die Segmente mit verschiedenen Effekten. Wähle zuletzt noch den passenden Soundtrack. Und fertig ist dein Slide!",
    step2Title: "2. Melde dich in den Spreewelten an",
    step2Text:
      "Am Terminal zum Rutschenbereich meldest du dich mit deinem Nickname und deinem Passwort an und speicherst deine Strecken auf deinem Chip-Armband. Gehe dann zum Start und lege los!",
    step3Title: "3. Hab Spaß!",
    step3Text:
      "Jetzt heißt es rutschen, bis der Hosenboden glüht! Sammle Kilometer und Punkte! Deine Statistiken siehst du dann jederzeit in deinem Account und an den Anzeigen über den Rutschen.",
  },
};

export default new MLCreate({
  initial: "deutsch",
  save: process.env.NODE_ENV === "production",
  middleware: (component, path) => {
    const newPath = `${component.$options.name}.${path}`;
    // you should return newPath
    return newPath;
  },
  languages: [new MLanguage("deutsch").create(texteDeu)],
});
